import { createContext } from "react";

export type WorkDayContextApi = {
  reload: () => Promise<unknown>;
};

export const WorkDayContext = createContext<WorkDayContextApi | null>(null);
